import { UAParser } from 'ua-parser-js';

export interface BrowserInfo {
  browser: string;
  browserVersion: string;
  os: string;
  device: string;
}

export interface LocationInfo {
  country?: string;
  region?: string;
  city?: string;
  timezone: string;
}

/**
 * Get browser and device information
 */
export function getBrowserInfo(): BrowserInfo {
  const parser = new UAParser();
  const result = parser.getResult();

  return {
    browser: result.browser.name || 'Unknown',
    browserVersion: result.browser.version || 'Unknown',
    os: `${result.os.name || 'Unknown'} ${result.os.version || ''}`.trim(),
    device: result.device.type || 'desktop', // mobile, tablet, desktop
  };
}

/**
 * Get location information from the browser timezone.
 *
 * Country is intentionally NOT fetched here. It used to call a third-party IP
 * geolocation service (ipapi.co) on every login/signup, which got rate limited
 * (HTTP 429). The API now resolves the country server-side from the request IP
 * using a local GeoLite2 database, so the client only needs to report timezone.
 */
export async function getLocationInfo(): Promise<LocationInfo> {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return {
    timezone,
  };
}

/**
 * Get all tracking data for login/signup
 */
export async function getTrackingData() {
  const browserInfo = getBrowserInfo();
  const locationInfo = await getLocationInfo();

  return {
    browserInfo,
    locationInfo,
  };
}

